export { default as ProjectStructuredData } from './project-structured-data';
